import MainFrame from "../MainFrame";
import { Button, useAuthenticator } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";

export default function SettingsPage() {
  const { signOut } = useAuthenticator();
  const navigate = useNavigate();

  const onSignOut = () => {
    navigate("/");
    signOut();
  };

  return (
    <MainFrame>
      <div>Settings</div>
      <Button onClick={onSignOut}>Sign Out</Button>
    </MainFrame>
  );
}
